'use strict';
module.exports = require('./Steps.vue');